export interface PizzaFlavorOption {
  product: any;
  productSize: any;
  price: number;
}

export function isPizzaProduct(product: any): boolean {
  return String(product?.tipo || '').toLowerCase() === 'pizza';
}

export function getPizzaSizePrice(size: any): number {
  const promotionalPrice = Number(size?.novoPreco);
  if (size?.novoPreco !== null && size?.novoPreco !== undefined && Number.isFinite(promotionalPrice) && promotionalPrice >= 0) {
    return promotionalPrice;
  }
  return Math.max(0, Number(size?.preco) || 0);
}

export function getAvailablePizzaSizes(product: any): any[] {
  return (Array.isArray(product?.tamanhos) ? product.tamanhos : [])
    .filter((size: any) => size && size.disponivel !== false && size?.template?.disponivel !== false);
}

export function findCompatiblePizzaSize(product: any, selectedSize: any): any | null {
  const templateSizeId = selectedSize?.template?.id;
  if (templateSizeId === null || templateSizeId === undefined) return null;

  return getAvailablePizzaSizes(product).find((size: any) =>
    String(size?.template?.id) === String(templateSizeId)
  ) || null;
}

export function buildPizzaFlavorOptions(products: any[], selectedSize: any): PizzaFlavorOption[] {
  if (!selectedSize) return [];

  return (products || [])
    .filter((product: any) => isPizzaProduct(product))
    .map((product: any) => {
      const productSize = findCompatiblePizzaSize(product, selectedSize);
      return productSize ? {product, productSize, price: getPizzaSizePrice(productSize)} : null;
    })
    .filter((option: PizzaFlavorOption | null): option is PizzaFlavorOption => !!option);
}

export function getPizzaMaxFlavors(size: any): number {
  return Math.max(1, Number(size?.qtdeSabores || size?.template?.qtdeSabores || 1));
}

export function calculatePizzaUnitPrice(product: any, selectedSize: any, flavorOptions: PizzaFlavorOption[],
                                        flavorQuantities: {[productId: string]: number}): number {
  if (!selectedSize) return 0;

  const selected = (flavorOptions || [])
    .map((option: PizzaFlavorOption) => ({
      price: option.price,
      qty: Math.max(0, Number(flavorQuantities?.[String(option.product?.id)] || 0))
    }))
    .filter((item: any) => item.qty > 0);

  if (!selected.length) return getPizzaSizePrice(selectedSize);

  const totalFlavors = selected.reduce((total: number, item: any) => total + item.qty, 0);
  const chargeType = String(product?.template?.tipoDeCobranca || '').toLowerCase();
  let price: number;

  if (chargeType === 'media') {
    price = selected.reduce((total: number, item: any) => total + (item.price * item.qty), 0) / totalFlavors;
  } else {
    price = Math.max(...selected.map((item: any) => item.price));
  }

  if (totalFlavors > 1) {
    price += Math.max(0, Number(product?.template?.taxaExtra) || 0);
  }

  return Math.round(price * 100) / 100;
}

export function buildPizzaFlavors(flavorOptions: PizzaFlavorOption[],
                                  flavorQuantities: {[productId: string]: number}): any[] {
  const flavors: any[] = [];

  (flavorOptions || []).forEach((option: PizzaFlavorOption) => {
    const qty = Math.max(0, Number(flavorQuantities?.[String(option.product?.id)] || 0));
    for (let index = 0; index < qty; index++) {
      flavors.push({
        produto: option.product.id,
        produtoTamanho: option.productSize,
        nome: option.product.nome,
        preco: option.price,
        qtde: 1
      });
    }
  });

  return flavors;
}
